import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #ececec;
  margin-top: 8px;
  padding: 20.5px 16px 20.5px 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  min-width: 400px;
`;

export const Cell: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 0 8px 0 0;
`;

export const CellSmall: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 50px;
`;

export const CellText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #424248;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 100px;
  align-items: center;
`;
